// extracted by mini-css-extract-plugin
export default {"root":"ItemInfo__root--whICa","pic":"ItemInfo__pic--OXwDV","info":"ItemInfo__info--39zb0","name":"ItemInfo__name--30Afr","size":"ItemInfo__size--uLRJJ"};